
const themeTypes = {
    changeTheme: 'CHANGE_THEME',
};

export default themeTypes;